import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuPositionPropType } from 'ui-components/prop-types/dropdown-menu-position';
import { OperatingSystemService } from 'ui-components/services/operating-system-service';

import { FormattedMessagePropType } from '../../prop-types/intl';
import messages from '../messages';

import style from './style.module.less';

const getPresetDisplayText = (preset) => {
  const modifierKeyName = OperatingSystemService.isMac() ? 'Cmd' : 'Ctrl';
  const hotkey = preset.hotKey ? ` -- ${modifierKeyName} + ${preset.hotKey.toUpperCase()}` : '';
  return preset.name + hotkey;
};

const preventDefault = (e) => {
  if (e && e.preventDefault) {
    e.preventDefault();
  }
};

const Presets = ({
  id,
  dropdownMenuType,
  presets,
  onManagePresetsClick,
  className = null,
  onPresetSelected,
  dropdownTogglerMessage,
  dropdownTogglerClassName,
  chevronClassName,
  menuPosition,
}) => {
  return (
    <DropdownMenu className={className} dropdownMenuType={dropdownMenuType} id={id} menuPosition={menuPosition}>
      <DropdownMenuToggler
        buttonSize='normal'
        chevronClassname={chevronClassName}
        className={dropdownTogglerClassName}
        onClick={preventDefault}
        theme='link'
      >
        {dropdownTogglerMessage || <FormattedMessage {...messages.actionName} />}
      </DropdownMenuToggler>
      {presets.map((preset) => (
        <DropdownMenuItem key={preset.presetId} onClick={() => onPresetSelected(preset)}>
          {getPresetDisplayText(preset)}
        </DropdownMenuItem>
      ))}
      {onManagePresetsClick && (
        <DropdownMenuItem className={style['manage-presets-option']} onClick={onManagePresetsClick}>
          <FormattedMessage {...messages.managePresets} />
        </DropdownMenuItem>
      )}
    </DropdownMenu>
  );
};

export default Presets;

Presets.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  presets: PropTypes.arrayOf(
    PropTypes.shape({
      presetId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hotKey: PropTypes.string,
    }),
  ).isRequired,
  onPresetSelected: PropTypes.func.isRequired,
  onManagePresetsClick: PropTypes.func,
  className: PropTypes.string,
  dropdownTogglerMessage: FormattedMessagePropType,
  dropdownTogglerClassName: PropTypes.string,
  chevronClassName: PropTypes.string,
  menuPosition: DropdownMenuPositionPropType,
};
